<button mat-icon-button [matMenuTriggerFor]="filterMenu">
  <span>
    @if (selectedItems.length > 0) {
      <mat-icon>filter_list</mat-icon>
    }
    @if (selectedSort==='desc') {
      <mat-icon>arrow_downward</mat-icon>
    }
    @if (selectedSort==='asc') {
      <mat-icon>arrow_upward</mat-icon>
    }
    <mat-icon>arrow_drop_down</mat-icon>
  </span>
</button>

<mat-menu #filterMenu="matMenu" xPosition="before" class="menu-overflow-hidden tf-mat-menu">
  <div class="container content-centered" (click) = "$event.stopPropagation()">
    <form>
      <div class="row">
        <div class="col-8" style="padding-left: 0px; padding-right: 16px; display: flex;">
          <button mat-button class="float-start" (click)="onSortAsc()">Sort Ascending</button>
        </div>
        <div class="col-4 ml-auto">
          <button class="float-right" style="min-width: 0px" mat-flat-button color="primary"  (click)="onValidation()">
            OK
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="padding-left: 0px">
          <button class="float-start" mat-button (click)="onSortDesc()">Sort Descending</button>
        </div>
      </div>
      @if (selectedSort) {
        <div class="row">
          <div class="col-12" style="padding-left: 0px">
            <button class="float-start" mat-button (click)="onSortClear()">Clear Sort</button>
          </div>
        </div>
      }

      @if (selectedItems.length) {
        <div>
          <div class="row">
            <div class="col-12" style="padding-left: 0px">
              <button class="float-start" mat-button (click)="onClearSelection()">Clear Selection</button>
            </div>
          </div>
        </div>
      }
      <div class="row">
        <ng-multiselect-dropdown name="multi"  class="col-12"
          [class]="'filter-dropdown'"
          [settings]="dropdownSettings"
          [data]="choices"
          [placeholder]="'Select Items'"
          [(ngModel)]="selectedItems"
          >
        </ng-multiselect-dropdown>
      </div>

    </form>
  </div>
</mat-menu>
